"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleSearchConsolePerformanceMetrics = exports.googleSearchConsolePerformanceMetricsResultSchema = exports.googleSearchConsolePerformanceMetricsArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.googleSearchConsolePerformanceMetricsArgsSchema = zod_1.z.object({
    siteUrl: zod_1.z
        .string()
        .describe('The Search Console property URL. Can be either:\n' +
        '• Domain property: sc-domain:example.com\n' +
        '• URL prefix property: https://example.com or https://www.example.com'),
    startDate: zod_1.z
        .string()
        .describe('Start date for performance data in YYYY-MM-DD format. e.g. 2024-01-01'),
    endDate: zod_1.z
        .string()
        .describe('End date for performance data in YYYY-MM-DD format. e.g. 2024-01-31'),
    dimensions: zod_1.z
        .array(zod_1.z.enum(['date', 'query', 'page', 'country', 'device', 'searchAppearance']))
        .nullish()
        .describe('Dimensions to group results by. Can include: date, query, page, country, device, searchAppearance. If not provided, returns aggregated data.'),
    rowLimit: zod_1.z
        .number()
        .nullish()
        .default(1000)
        .describe('Maximum number of rows to return. Defaults to 1000. Maximum is 25000.'),
    startRow: zod_1.z
        .number()
        .nullish()
        .default(0)
        .describe('Starting row index for pagination. Defaults to 0.'),
    filters: zod_1.z
        .array(zod_1.z.object({
        dimension: zod_1.z.enum(['query', 'page', 'country', 'device', 'searchAppearance']),
        expression: zod_1.z
            .string()
            .describe('Filter expression (e.g., exact query, URL pattern, country code)'),
        operator: zod_1.z
            .enum(['equals', 'notEquals', 'contains', 'notContains'])
            .nullish()
            .default('equals')
            .describe('Filter operator. Defaults to equals.'),
    }))
        .nullish()
        .describe('Optional filters to apply to the query'),
    emitMode: common_1.emitModeSchema.default('single').describe('The mode to emit the data in.'),
});
exports.googleSearchConsolePerformanceMetricsResultSchema = zod_1.z.object({
    rows: zod_1.z.array(zod_1.z.object({
        keys: zod_1.z
            .array(zod_1.z.string())
            .describe('Dimension values for this row (e.g., [query, page, date])'),
        clicks: zod_1.z.number().describe('Number of clicks from search results'),
        impressions: zod_1.z.number().describe('Number of times the site appeared in search results'),
        ctr: zod_1.z.number().describe('Click-through rate (clicks / impressions)'),
        position: zod_1.z.number().describe('Average position in search results'),
    })),
    responseAggregationType: zod_1.z
        .string()
        .nullish()
        .describe('How the data was aggregated (e.g., by date, by query, etc.)'),
    totalRows: zod_1.z.number().nullish().describe('Total number of rows available (for pagination)'),
});
exports.googleSearchConsolePerformanceMetrics = (0, common_1.createEmitModeToolMetadata)({
    id: 'googleSearchConsolePerformanceMetrics',
    displayName: 'Google Search Console Performance Metrics',
    displayDescription: 'Get search performance metrics from Google Search Console including clicks, impressions, CTR, and average position. Filter and group by dimensions like date, query, page, country, or device.',
    category: 'seo',
    color: common_1.BRAND_COLORS.GOOGLE_ADS,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_ADS),
    icon: 'search',
    argsSchema: exports.googleSearchConsolePerformanceMetricsArgsSchema,
}, exports.googleSearchConsolePerformanceMetricsResultSchema);
